import {Component, Input, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {ValueClockModel} from '@models/index';
import {ClockService} from '@services/clock-service.service';
/**
  Componente que muestra un reloj en tiempo real.
  Este componente obtiene la hora, minutos, segundos, día de la semana, fecha y formato AM/PM
  desde un servicio y los muestra en la interfaz de usuario. También permite personalizar
  el estilo del reloj según el contexto (por ejemplo, para un entorno de RB).
**/
@Component({
    selector: 'am-clock',
    templateUrl: './clock.component.html',
    styleUrls: ['./clock.component.scss'],
    standalone: false
})
export class ClockComponent implements OnInit {

  /**
    Indica si el reloj debe usar un estilo específico para RB (Reembolso).
    @type {boolean}
    @default false
  **/
    @Input() isrb: boolean = false;

    /**
      Observable que proporciona la información del reloj en tiempo real.
      @type {Observable<ValueClockModel>}
    **/
    datos$: Observable<ValueClockModel>;
  
    /**
      Hora actual.
      @type {number}
    **/
    hora: number;
  
    /**
      Minutos actuales.
      @type {string}
    **/
    minutos: string;
  
    /**
      Día de la semana actual.
      @type {string}
    **/
    dia: string;
  
    /**
      Fecha actual en formato día y mes.
      @type {string}
    **/
    fecha: string;
  
    /**
      Formato AM/PM actual.
      @type {string}
    **/
    ampm: string;
  
    /**
      Segundos actuales.
      @type {string}
    **/
    segundos: string;

  constructor(private segundo: ClockService) {
  }

  ngOnInit(): void {
    this.datos$ = this.segundo.getInfoReloj();
    this.datos$.subscribe(x => {
      this.hora = x.hora;
      this.minutos = x.minutos;
      this.dia = x.diadesemana;
      this.fecha = x.diaymes;
      this.ampm = x.ampm;
      this.segundos = x.segundo;
    });
  }

}
